<template>
  <div
    :style="{
      width: 90 + 'px',
      height: 150 + 'px',
    }"
    class="absolute"
  >
    <Charts :options="option" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import Charts from "@/components/Charts";
import { getDefaultChartOptions } from "./helper";
interface Props {
  value: number;
  max?: number;
  min?: number;
  position?: "left" | "right";
}
const props = withDefaults(defineProps<Props>(), {
  value: 0,
  max: 50,
  min: 0,
  position: "right",
});

// watch(
//   () => props,
//   (newValue) => {
//     console.log("[ZJL]🚀 ~ watch ~ newValue:", newValue);
//   },
//   { deep: true }
// );

const option = computed(() => getDefaultChartOptions(props));
</script>
<style scoped>
.chart {
  height: 100%;
  width: 100%;
}
</style>
